import React from 'react';
import { Controller, DeepMap, FieldError, FieldValues, FieldPath, UseControllerProps } from 'react-hook-form';
import PasswordInputText from '../../ui/PasswordInputText';
import { PasswordInputTextProps } from '../../ui/PasswordInputText/PasswordInputText';

type FormPasswordInputTextProps<T> = UseControllerProps<T & FieldValues> & {
  name: FieldPath<T & FieldValues>;
  errors?: Partial<DeepMap<T & FieldValues, FieldError>>;
} & PasswordInputTextProps;

const FormPasswordInputText = <T extends FieldValues>({
  control,
  name,
  errors = {},
  ...other
}: FormPasswordInputTextProps<T>) => {
  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          <PasswordInputText error={errors?.[name]?.message} name={name} {...field} {...other} ref={null} />
        )}
      />
    </>
  );
};

export default FormPasswordInputText;
